export const END_STATE_MARKERS = {
  // Tab zalgoification starts as soon as endState > 0
  GAME_END: 1,
  TAB_START_HIDE: 1.5,
  INTERACTIVITY_DISABLED: 2.5,
  FADE_AWAY: 2.5,
  SAVE_DISABLED: 4,
  END_NUMBERS: 4.2,
  CREDITS_START: 4.5,
  SHOW_NEW_GAME: 13.5,
  SPECTATE_GAME: 13.9,
  // The song is 3:04 and the credits increment by 1 every 20 seconds. Needs changing if the song is changed.
  SONG_END: 13.7,
  CREDITS_END: 14.5,
};

export const GameEnd = {
  get endState() {
    if (this.removeAdditionalEnd) return this.additionalEnd;
    return Math.max(
      (Math.log10(player.celestials.pelle.records.totalAntimatter.plus(1).log10() + 1) - 8.7) /
        (Math.log10(9e15) - 8.7) +
        this.additionalEnd,
      0,
    );
  },

  get beaten() {
    return GameEnd.endState > END_STATE_MARKERS.GAME_END && !GameEnd.removeAdditionalEnd;
  },

  _additionalEnd: 0,
  get additionalEnd() {
    // Don't hide the tabs
    let end = player.isGameEnd || this.removeAdditionalEnd ? this._additionalEnd : 0;
    if (AtomMilestone.am1.isReached) end = Math.min(end, 0.499);
    return end;
  },
  set additionalEnd(x) {
    this._additionalEnd = player.isGameEnd || this.removeAdditionalEnd ? x : 0;
  },

  removeAdditionalEnd: false,

  creditsClosed: false,
  creditsEverClosed: false,

  gameLoop(diff) {
    if (this.removeAdditionalEnd) {
      this.additionalEnd -= Math.min(diff / 200, 0.5);
      if (this.additionalEnd < 4) {
        this.additionalEnd = 0;
        this.removeAdditionalEnd = false;
      }
    }
    if (
      !this.removeAdditionalEnd &&
      this.endState >= END_STATE_MARKERS.GAME_END &&
      ui.$viewModel.modal.progressBar === undefined
    ) {
      player.isGameEnd = true;
      this.additionalEnd += Math.min(diff / 1000 / 20, 0.1);
    }
  },
};
